import React, { useContext } from "react";
import { useQuery } from "react-query";
import { ContainerWithSidebar } from "components/layout";
import Spinner from "components/spinner";
import { getVendors } from "../../../api/vendorsApi";
import { VendorContext, VendorProvider } from "contexts/VendorContext";
import VendorsList from "../VendorsList/VendorsList";
import VendorsToolBar from "../VendorsToolBar/VendorsToolBar";
import VendorBody from "../VendorBody/VendorBody";
import VendorFormModal from "../components/VendorFormModal";
import { useModalContext } from "components/modal";
import { useCompanyFeature } from "hooks/useCompanyFeature";
import { useTranslation } from "react-i18next";
import { openLinkItemModal } from "../utils/openLinkItemModal";


import styles from "./VendorsIndex.module.scss";

const VendorEditModalHost = ({ refetch }: { refetch: () => void }) => {
  const {
    currentVendor,
    isVendorEditModalOpen,
    heritageCredentialsFocusOnOpen,
    closeVendorEditModal,
    clearHeritageCredentialsFocus,
  } = useContext(VendorContext);
  const { setModal } = useModalContext();
  const heritageFeatureEnabled = useCompanyFeature("heritage");
  const { t } = useTranslation();

  // #31 — after a purchase-history download, close Edit Vendor and land the
  // user straight on the link page for that vendor. Same modal assembly as the
  // Link Item button (openLinkItemModal), so both paths show the same screen.
  const handlePurchaseHistoryDownloaded = () => {
    if (!currentVendor) {
      return;
    }
    closeVendorEditModal();
    openLinkItemModal(setModal, {
      vendorId: currentVendor.vendor_id,
      isSiteoneVendor: currentVendor.is_siteone,
      isHeritageVendor: heritageFeatureEnabled && Boolean(currentVendor.is_heritage),
      label: t("views.vendors.VendorBody.VendorItems.VendorItems.Link Item"),
    });
  };

  return (
    <VendorFormModal
      mode="edit"
      isOpen={isVendorEditModalOpen}
      onClose={closeVendorEditModal}
      refetch={refetch}
      vendor={currentVendor}
      focusHeritageCredentials={heritageCredentialsFocusOnOpen}
      onHeritageCredentialsFocusHandled={clearHeritageCredentialsFocus}
      onPurchaseHistoryDownloaded={handlePurchaseHistoryDownloaded}
    />
  );
};

const VendorsIndex = () => {
  const vendorsQuery = useQuery("vendors", getVendors);
  //   const unmatched = useQuery("unmatched",  async () =>
  //     await axios
  //       .get(
  //         `${process.env.REACT_APP_SERVER_URL}/api/v1/company/vendors/unmatched`
  //       )
  //       .then((res) => res.data)
  //   );
  // const unmatched = useQuery("unmatched",  async () =>
  //   await axios
  //     .get(
  //       `${process.env.REACT_APP_SERVER_URL}/api/v1/company/vendors/unmatched`
  //     )
  //     .then((res) => res.data)
  // );
  //  const Mergeitemsmodal = () => {
  //   const [withId, setWithId] = useState('');
  //   const [withVPN, setWithVPN] = useState('');
  //   const unmatched = useQuery("unmatched",  async () =>
  //   await axios
  //     .get(
  //       `${process.env.REACT_APP_SERVER_URL}/api/v1/company/vendors/unmatched`
  //     )
  //     .then((res) => res.data)
  //   );
  //   return(
  //     <div style={{display:'flex', flexDirection:'row', padding:'20px'}}>
  //     <select onChange={(e)=>{
  //       setWithVPN(e.target.value)
  //     }} style={{display:'flex',flex:'50%', flexDirection:'column'}}>
  //       <option style = {{display:'flex'}} value={''}>
  //             {'Vendor confirmed items'}</option>
  //       {unmatched?.data?.noId?.map((item:any) => {
  //         return(
  //           <option style = {{display:'flex'}} value={item?.id}>
  //             {'('+item?.id +') '+item?.notes?.split(',')[1]}
  //           </option>
  //         )
  //       })}
  //     </select>
  //     <select onChange={(e)=>{
  //       setWithId(e.target.value)
  //     }} style={{display:'flex',flex:'50%', flexDirection:'column'}}>
  //        <option style = {{display:'flex'}} value={''}>
  //             {'Items without vendor IDs'}</option>
  //     {unmatched?.data?.noVPN?.map((item:any) => {
  //       return(
  //         <option style = {{display:'flex'}} value={item?.item_id}>
  //           {'('+item?.item_id +') '+item?.name}
  //         </option>
  //       )
  //     })}</select>
  //     <Button primary style={{display:'flex', flexDirection:'column'}} onClick={()=>{
  //       axios.post(`${process.env.REACT_APP_SERVER_URL}/api/v1/company/vendors/merge`,{
  //         withId:withId,
  //         withVPN:withVPN
  //       }).then((res)=>{
  //        
  //       })
  //     }}>
  //       {'Merge'}
  //     </Button>
  //     </div>
  //   )
  //  } 
  //   const Unmatchedwarning = () => {
  //     if (unmatched?.data?.noId?.length > 0) {
  //       return <div onClick={()=>{
  //         setModal({
  //           component:<Mergeitemsmodal/>,
  //           label:'combine items'})
  //       }} style={{color:'#f00', cursor:'pointer', display:'flex',margin:'auto'}}><RiFileWarningLine style={{display:'inline'}}/>{' items without VPN '}<RiFileWarningLine style={{display:'inline'}}/></div>;
  //     } else {
  //       return <></>;
  //     }
  //   }
  if (vendorsQuery?.isLoading) return <Spinner />;

  //   if (vendorsQuery?.isError) return <div>Error</div>;

  const handleRefetch = () => {
    vendorsQuery.refetch();
  }

  // TODO: organize all the inline and module css styles in VendorToolBar, VendorBody, VendorDetails, and VendorDetailItem

  return (
    <VendorProvider>
      <ContainerWithSidebar>
        <div className={styles.sidebarContainer}>
          <VendorsList vendors={vendorsQuery?.data} />
          {/* <Unmatchedwarning/> */}

        </div>
        <div className={styles.bodyContainer}>
          <VendorsToolBar refetch={handleRefetch} />
          <VendorBody refetch={handleRefetch} />
          <VendorEditModalHost refetch={handleRefetch} />
        </div>
      </ContainerWithSidebar>
    </VendorProvider>
  );
};

export default VendorsIndex;
